// Common
import { Component, OnDestroy, OnInit } from '@angular/core';
import { SidebarItemComponent } from '@modules/common/components/sidebar-item/sidebar-item.component';
import { DragNDropModule } from '@modules/drag-n-drop/drag-n-drop.module';
import { ClickDirective } from '@modules/utils/directives/click/click.directive';
import { NavigationEnd, Router } from '@angular/router';

// Types
import { SidebarItem } from '@modules/common/types/sidebar-item';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-admin-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.less'],
  imports: [DragNDropModule, SidebarItemComponent, ClickDirective],
})
export class AdminSideBarComponent implements OnInit, OnDestroy {
  public currentItemId: string;
  public currentContainerId: string;
  public items: SidebarItem[] = [
    { title: 'Users', icon: 'sapphire-contact', id: 'users' },
    { title: 'Spaces', icon: 'sapphire-groups', id: 'spaces' },
    { title: 'Space cleanup', icon: 'sapphire-groups', id: 'space-cleanup' },

    { title: 'Subscription Plans', icon: 'sapphire-groups', id: 'plans' },
    { title: 'Plans', id: 'plans/plans', parentId: 'plans' },
    { title: 'Config', id: 'plans/config', parentId: 'plans' },

    { title: 'Emails', icon: 'sapphire-email', id: 'emails' },
    { title: 'Templates', id: 'emails/templates', parentId: 'emails' },
    { title: 'Placeholders', id: 'emails/placeholders', parentId: 'emails' },

    { title: 'Rspamd', icon: 'sapphire-spam', id: 'rspamd' },
    { title: 'Reindex Docs', icon: 'refresh', id: 'reindex' },
    { title: 'Audit Log', icon: 'sapphire-list-view', id: 'audit-log' },
    { title: 'Reserved names', icon: 'sapphire-lock', id: 'reserved-names' },
    { title: 'Waitlist', icon: 'sapphire-time', id: 'waitlist' },
    { title: 'AI operations', icon: 'stitchy-head', id: 'ai-operations' },
  ];

  private alive = new Subject<void>();

  constructor(private router: Router) {}

  ngOnInit() {
    this.setItem(this.router.url);

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.alive),
      )
      .subscribe((event: NavigationEnd) => {
        this.setItem(event.url);
      });
  }

  ngOnDestroy() {
    this.alive.next();
    this.alive.complete();
  }

  /**
   * Actions
   */

  selectFilter(item: SidebarItem): void {
    this.router.navigate([`/admin/${item.id}`]);
  }

  setItem(url: string) {
    const pathElements = url.split('/').slice(2);

    this.currentItemId = pathElements.join('/');
    this.currentContainerId = pathElements[0];
  }
}
